/**
 * 选项的默认值
 */
export default {
  id: '',
  title: '',
  exampleImages: [],
  exampleText: '',
  needEvidence: true,
  localFile: false,
  referIds: [],
  minDuration: '0',
  nextSelectDelay: '0',
  takePhotoAuxiliaryLine: 0,
  mutexOptions: [],
  images: [],
  inputType: 'text',
  inputMin: null,
  inputMax: null,
  required: true,
  jumpTargetId: '',
  settlementType: 0,
  settlementAmount: 0,
  settlementAmountRatio: 1,
  dataLabel: '',
  intelligentCall: false,
  autoIncreaseTaskGroupTarget: false,
}



// WEBPACK FOOTER //
// ./src/views/question-editor/format/convert-fields/option.js